<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/?page=reports"></top-nav-bar>

        <div class="max-w-sm mx-auto px-4 overflow-y-auto pb-16 md:pb-0 py-2">
            <h3 class="text-center mb-8">File a new report</h3>
            <form-group label="Report" name="report" :required="true" v-if="!report">
                <div class="select">
                    <select v-model="report" id="report" class="input">
                        <option value="">Select a Report</option>
                        <option v-for="(name, slug) in reports" :value="slug">
                            {{name}}
                        </option>
                    </select>
                </div>
            </form-group>

            <incident-and-deviation v-if="report === 'incident-deviation'"></incident-and-deviation>
            <daily-flight-performance v-if="report === 'daily-flight'"></daily-flight-performance>
            <fatigue v-if="report === 'fatigue'"></fatigue>
            <performance-review v-if="report === 'performance-review'"></performance-review>
            <occupational-accident v-if="report === 'occupational-accident'"></occupational-accident>
        </div>
    </div>
</template>

<script>
    import IncidentAndDeviation from '@/partials/reports/IncidentAndDeviation.vue'
    import DailyFlightPerformance from '@/partials/reports/DailyFlightPerformance.vue'
    import Fatigue from '@/partials/reports/Fatigue.vue'
    import PerformanceReview from '@/partials/reports/PerformanceReview.vue'
    import OccupationalAccident from '@/partials/reports/OccupationalAccident.vue'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [CanAccessView],

        components: {
            IncidentAndDeviation,
            DailyFlightPerformance,
            Fatigue,
            OccupationalAccident,
            PerformanceReview
        },

        data() {
            return {
                reportData: false,
                reports: {},
                routes: {},
                injuries: {},
                accidentPlaces: {},
                flights: {},
                factors: {},
            }
        },

        computed: {
            report() {
                return this.$route.params.type || null;
            }
        },

        mounted() {
            this.$api('hr').get('reports/create')
                .then(({data}) => {
                    this.reports = data.data.reports;
                    this.factors = data.data.factors;
                    this.routes = data.data.routes;
                    this.injuries = data.data.injuries;
                    this.accidentPlaces = data.data.accident_places;
                    this.flights = data.data.flights;

                    this.reportData = null;
                });
        }
    }
</script>
